import { useConfiguredForm } from '@wyz/ui';
import { useFormContext } from 'react-hook-form';
import { IBrandTemplateForm, TabGroupType } from '~/connect/types';
import { IBrand } from '~/common/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import BaseAlphabeticalList from './base-alphabetical-list';

type Props = {
  currentTab: string;
  searchQuery: string;
  onAdd: (brand: IBrand) => void;
  onRemove: (publicKey: string) => void;
  itemsByTab: TabGroupType<IBrand>[string];
};

function BrandAlphabeticalList({
  currentTab,
  searchQuery,
  onAdd,
  onRemove,
  itemsByTab,
}: Props) {
  const methods = useFormContext<IBrandTemplateForm>();
  const configurationContext = useConfiguredForm();

  return (
    <BaseAlphabeticalList.Container>
      <BaseAlphabeticalList.Letters
        getLetterKey={(letter) => `${currentTab}-${letter}`}
        itemsByLetter={itemsByTab}
      />
      <BaseAlphabeticalList.List<IBrand, string>
        itemsByLetter={itemsByTab}
        getLetterKey={(letter) => `${currentTab}-${letter}`}
        getItemIdentifier={(item) => item.publicKey}
        getItemLabel={(item) => item.name}
        isAdded={(item) =>
          Boolean(
            methods
              .getValues('brands')
              .find((_item) => _item.publicKey === item.publicKey),
          )
        }
        canConfigure={configurationContext.mode !== 'READ_ONLY'}
        canAdd={configurationContext.mode !== 'READ_ONLY'}
        canRemove={configurationContext.mode !== 'READ_ONLY'}
        onAdd={onAdd}
        onRemove={(item) => onRemove(item.publicKey)}
        preFilterer={(brand) =>
          !searchQuery
            ? true
            : brand.name
                .trim()
                .toLowerCase()
                .includes(searchQuery.trim().toLowerCase())
        }
      />
    </BaseAlphabeticalList.Container>
  );
}

export default BrandAlphabeticalList;
